export const STUDY_MATERIALS_COPY = {
    default: {
        header: {
            title: "Study Materials Management",
            closeAria: "Close study materials modal",
        },
        storageNotice: "ℹ️ Storage: Uploaded study materials are stored directly in the database and immediately accessible to students and instructors.",
        toggles: {
            show: "Show Upload Form",
            hide: "Hide Form",
        },
        confirm: {
            delete: "Are you sure you want to delete this study material?",
        },
        upload: {
            heading: "Upload New Material",
            labels: {
                title: "Title",
                category: "Category",
                description: "Description",
                file: "Select File",
            },
            placeholders: {
                title: "Enter material title",
                description: "Enter material description",
            },
            options: {
                general: "General",
                cdlManual: "CDL Manual",
                practiceTests: "Practice Tests",
                trainingVideos: "Training Videos",
                safetyGuidelines: "Safety Guidelines",
                regulations: "Regulations",
            },
            fileHint: "Accepted: PDF, DOC, PPT, MP4, MP3, Images including HEIC (Max 50MB)",
            button: {
                upload: "Upload Material",
                uploading: "Uploading...",
            },
        },
        list: {
            heading: "Study Materials",
            loading: "Loading materials...",
            emptyTitle: "No study materials yet",
            emptyMessage: "Upload your first material to get started",
            actions: {
                preview: "Preview",
                download: "Download",
                delete: "Delete",
            },
        },
        preview: {
            title: "Preview: {title}",
            loading: "Loading preview...",
            error: "Failed to preview material. Please download instead.",
            closeAria: "Close preview",
        },
        alerts: {
            deleteSuccess: "Study material deleted successfully!",
            downloadFailed: "Failed to download file. Please try again.",
            fileNotFound: "⚠️ File Not Available\n\n{message}\n\nMaterial: {title}\nID: {id}",
        },
        errors: {
            fetch: "Failed to load study materials",
            invalidSize: "File size must be less than 50MB",
            missingFields: "Please select a file and enter a title",
            uploadFailed: "Failed to upload study material",
            deleteFailed: "Failed to delete material",
            previewFailed: "Failed to preview material. Please download instead.",
        },
    },
    uk: {
        header: {
            title: "Керування навчальними матеріалами",
            closeAria: "Закрити вікно навчальних матеріалів",
        },
        storageNotice: "ℹ️ Зберігання: завантажені матеріали одразу доступні студентам та інструкторам і зберігаються прямо в базі даних.",
        toggles: {
            show: "Показати форму завантаження",
            hide: "Сховати форму",
        },
        confirm: {
            delete: "Видалити цей навчальний матеріал?",
        },
        upload: {
            heading: "Завантажити новий матеріал",
            labels: {
                title: "Назва",
                category: "Категорія",
                description: "Опис",
                file: "Виберіть файл",
            },
            placeholders: {
                title: "Введіть назву матеріалу",
                description: "Додайте опис матеріалу",
            },
            options: {
                general: "Загальні",
                cdlManual: "Посібник CDL",
                practiceTests: "Практичні тести",
                trainingVideos: "Навчальні відео",
                safetyGuidelines: "Інструкції з безпеки",
                regulations: "Нормативи",
            },
            fileHint: "Допустимі формати: PDF, DOC, PPT, MP4, MP3, зображення включно зі HEIC (до 50 МБ)",
            button: {
                upload: "Завантажити матеріал",
                uploading: "Завантаження...",
            },
        },
        list: {
            heading: "Навчальні матеріали",
            loading: "Завантаження матеріалів...",
            emptyTitle: "Матеріали ще не додано",
            emptyMessage: "Завантажте перший матеріал, щоб розпочати",
            actions: {
                preview: "Переглянути",
                download: "Завантажити",
                delete: "Видалити",
            },
        },
        preview: {
            title: "Попередній перегляд: {title}",
            loading: "Завантаження попереднього перегляду...",
            error: "Не вдалося переглянути матеріал. Завантажте файл.",
            closeAria: "Закрити попередній перегляд",
        },
        alerts: {
            deleteSuccess: "Навчальний матеріал успішно видалено!",
            downloadFailed: "Не вдалося завантажити файл. Спробуйте ще раз.",
            fileNotFound: "⚠️ Файл недоступний\n\n{message}\n\nМатеріал: {title}\nID: {id}",
        },
        errors: {
            fetch: "Не вдалося завантажити навчальні матеріали",
            invalidSize: "Розмір файлу має бути менше 50 МБ",
            missingFields: "Виберіть файл і введіть назву",
            uploadFailed: "Не вдалося завантажити матеріал",
            deleteFailed: "Не вдалося видалити матеріал",
            previewFailed: "Не вдалося переглянути матеріал. Завантажте файл.",
        },
    },
    ru: {
        header: {
            title: "Управление учебными материалами",
            closeAria: "Закрыть окно учебных материалов",
        },
        storageNotice: "ℹ️ Хранение: загруженные материалы сразу доступны студентам и инструкторам и хранятся напрямую в базе данных.",
        toggles: {
            show: "Показать форму загрузки",
            hide: "Скрыть форму",
        },
        confirm: {
            delete: "Удалить этот учебный материал?",
        },
        upload: {
            heading: "Загрузить новый материал",
            labels: {
                title: "Название",
                category: "Категория",
                description: "Описание",
                file: "Выберите файл",
            },
            placeholders: {
                title: "Введите название материала",
                description: "Добавьте описание материала",
            },
            options: {
                general: "Общие",
                cdlManual: "CDL руководство",
                practiceTests: "Практические тесты",
                trainingVideos: "Учебные видео",
                safetyGuidelines: "Рекомендации по безопасности",
                regulations: "Регламенты",
            },
            fileHint: "Допустимые форматы: PDF, DOC, PPT, MP4, MP3, изображения включая HEIC (до 50 МБ)",
            button: {
                upload: "Загрузить материал",
                uploading: "Загрузка...",
            },
        },
        list: {
            heading: "Учебные материалы",
            loading: "Загрузка материалов...",
            emptyTitle: "Материалы пока отсутствуют",
            emptyMessage: "Загрузите первый материал, чтобы начать",
            actions: {
                preview: "Просмотр",
                download: "Скачать",
                delete: "Удалить",
            },
        },
        preview: {
            title: "Предпросмотр: {title}",
            loading: "Загрузка предпросмотра...",
            error: "Не удалось просмотреть материал. Скачайте файл.",
            closeAria: "Закрыть предпросмотр",
        },
        alerts: {
            deleteSuccess: "Учебный материал успешно удалён!",
            downloadFailed: "Не удалось скачать файл. Попробуйте ещё раз.",
            fileNotFound: "⚠️ Файл недоступен\n\n{message}\n\nМатериал: {title}\nID: {id}",
        },
        errors: {
            fetch: "Не удалось загрузить учебные материалы",
            invalidSize: "Размер файла должен быть меньше 50 МБ",
            missingFields: "Выберите файл и введите название",
            uploadFailed: "Не удалось загрузить материал",
            deleteFailed: "Не удалось удалить материал",
            previewFailed: "Не удалось просмотреть материал. Скачайте файл.",
        },
    },
    es: {
        header: {
            title: "Gestión de materiales de estudio",
            closeAria: "Cerrar el modal de materiales de estudio",
        },
        storageNotice: "ℹ️ Almacenamiento: los materiales subidos se guardan directamente en la base de datos y están disponibles de inmediato para estudiantes e instructores.",
        toggles: {
            show: "Mostrar formulario de carga",
            hide: "Ocultar formulario",
        },
        confirm: {
            delete: "¿Eliminar este material de estudio?",
        },
        upload: {
            heading: "Subir nuevo material",
            labels: {
                title: "Título",
                category: "Categoría",
                description: "Descripción",
                file: "Seleccionar archivo",
            },
            placeholders: {
                title: "Introduce el título del material",
                description: "Introduce la descripción del material",
            },
            options: {
                general: "General",
                cdlManual: "Manual CDL",
                practiceTests: "Pruebas de práctica",
                trainingVideos: "Videos de entrenamiento",
                safetyGuidelines: "Guías de seguridad",
                regulations: "Reglamentos",
            },
            fileHint: "Formatos permitidos: PDF, DOC, PPT, MP4, MP3, imágenes incluyendo HEIC (máx. 50 MB)",
            button: {
                upload: "Subir material",
                uploading: "Subiendo...",
            },
        },
        list: {
            heading: "Materiales de estudio",
            loading: "Cargando materiales...",
            emptyTitle: "Aún no hay materiales de estudio",
            emptyMessage: "Sube tu primer material para comenzar",
            actions: {
                preview: "Vista previa",
                download: "Descargar",
                delete: "Eliminar",
            },
        },
        preview: {
            title: "Vista previa: {title}",
            loading: "Cargando vista previa...",
            error: "No se pudo mostrar el material. Descárgalo en su lugar.",
            closeAria: "Cerrar vista previa",
        },
        alerts: {
            deleteSuccess: "¡Material de estudio eliminado correctamente!",
            downloadFailed: "No se pudo descargar el archivo. Inténtalo de nuevo.",
            fileNotFound: "⚠️ Archivo no disponible\n\n{message}\n\nMaterial: {title}\nID: {id}",
        },
        errors: {
            fetch: "No se pudieron cargar los materiales de estudio",
            invalidSize: "El archivo debe pesar menos de 50 MB",
            missingFields: "Selecciona un archivo e introduce un título",
            uploadFailed: "No se pudo subir el material",
            deleteFailed: "No se pudo eliminar el material",
            previewFailed: "No se pudo previsualizar el material. Descárgalo en su lugar.",
        },
    },
};

export const STUDENT_STUDY_MATERIALS_COPY = {
    default: {
        header: {
            title: "Study Materials",
            closeAria: "Close study materials modal",
        },
        list: {
            loading: "Loading study materials...",
            emptyTitle: "No study materials available",
            emptyMessage: "Check back later for new materials",
            actions: {
                preview: "Preview",
                download: "Download",
            },
        },
        preview: {
            title: "Preview: {title}",
            loading: "Loading preview...",
            error: "Preview not available. Please download the file instead.",
            closeAria: "Close preview",
        },
        errors: {
            fetch: "Failed to load study materials",
            previewFailed: "Preview not available. Please download the file instead.",
            downloadFailed: "Failed to download file. Please try again.",
        },
    },
    uk: {
        header: {
            title: "Навчальні матеріали",
            closeAria: "Закрити вікно навчальних матеріалів",
        },
        list: {
            loading: "Завантаження навчальних матеріалів...",
            emptyTitle: "Навчальні матеріали недоступні",
            emptyMessage: "Завітайте пізніше, щоб переглянути нові матеріали",
            actions: {
                preview: "Переглянути",
                download: "Завантажити",
            },
        },
        preview: {
            title: "Попередній перегляд: {title}",
            loading: "Завантаження попереднього перегляду...",
            error: "Попередній перегляд недоступний. Завантажте файл.",
            closeAria: "Закрити попередній перегляд",
        },
        errors: {
            fetch: "Не вдалося завантажити навчальні матеріали",
            previewFailed: "Попередній перегляд недоступний. Завантажте файл.",
            downloadFailed: "Не вдалося завантажити файл. Спробуйте ще раз.",
        },
    },
    ru: {
        header: {
            title: "Учебные материалы",
            closeAria: "Закрыть окно учебных материалов",
        },
        list: {
            loading: "Загрузка учебных материалов...",
            emptyTitle: "Учебные материалы недоступны",
            emptyMessage: "Загляните позже, чтобы увидеть новые материалы",
            actions: {
                preview: "Просмотр",
                download: "Скачать",
            },
        },
        preview: {
            title: "Предпросмотр: {title}",
            loading: "Загрузка предпросмотра...",
            error: "Предпросмотр недоступен. Скачайте файл.",
            closeAria: "Закрыть предпросмотр",
        },
        errors: {
            fetch: "Не удалось загрузить учебные материалы",
            previewFailed: "Предпросмотр недоступен. Скачайте файл.",
            downloadFailed: "Не удалось скачать файл. Попробуйте ещё раз.",
        },
    },
    es: {
        header: {
            title: "Materiales de estudio",
            closeAria: "Cerrar el modal de materiales de estudio",
        },
        list: {
            loading: "Cargando materiales de estudio...",
            emptyTitle: "No hay materiales de estudio disponibles",
            emptyMessage: "Vuelve más tarde para ver nuevos materiales",
            actions: {
                preview: "Vista previa",
                download: "Descargar",
            },
        },
        preview: {
            title: "Vista previa: {title}",
            loading: "Cargando vista previa...",
            error: "La vista previa no está disponible. Descarga el archivo.",
            closeAria: "Cerrar vista previa",
        },
        errors: {
            fetch: "No se pudieron cargar los materiales de estudio",
            previewFailed: "La vista previa no está disponible. Descarga el archivo.",
            downloadFailed: "No se pudo descargar el archivo. Inténtalo de nuevo.",
        },
    },
};
